import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import {
  AddressBookDtoCreate,
  AddressBookDtoUpdate,
  AddressBookItem,
  RegistryItem,
} from 'src/app/api/models';
import { AddressBookService, RegistryService } from 'src/app/api/services';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-modal-address-book-form',
  templateUrl: './modal-address-book-form.component.html',
  styleUrls: ['./modal-address-book-form.component.scss'],
})
export class ModalAddressBookFormComponent {
  @Input() registry_end_customer_id?: number;
  registry_end_customer?: RegistryItem;
  @Input() registry_end_customer_contact_id?: number;
  registry_end_customer_contact?: AddressBookItem;

  @Output() closing: EventEmitter<AddressBookItem> = new EventEmitter();

  frm = new FormGroup({
    name: new FormControl<string | undefined>(undefined, [Validators.required]),
    last_name: new FormControl<string | undefined>(undefined, [Validators.required]),
    job_title: new FormControl<string | undefined>(undefined),
    email: new FormControl<string | undefined>(undefined, [Validators.email]),
    alternative_email: new FormControl<string | undefined>(undefined, [Validators.email]),
    address: new FormControl<string | undefined>(undefined),
    province: new FormControl<string | undefined>(undefined),
    city: new FormControl<string | undefined>(undefined),
    zip_code: new FormControl<string | undefined>(undefined, {
      validators: [Validators.maxLength(5)],
    }),
    phone_number: new FormControl<string | undefined>(undefined),
    alternative_phone_number: new FormControl<string | undefined>(undefined),
    fax_number: new FormControl<string | undefined>(undefined),
    building: new FormControl<string | undefined>(undefined),
    floor: new FormControl<string | undefined>(undefined),
    room: new FormControl<string | undefined>(undefined),
    directions: new FormControl<string | undefined>(undefined),
    linkedin_url: new FormControl<string | undefined>(undefined),
    notes: new FormControl<string | undefined>(undefined),
  });

  constructor(
    private messageService: MessageService,
    public auth: AuthService,
    private router: Router,
    private ar: ActivatedRoute,
    private contactService: AddressBookService,
    private registryService: RegistryService,
    private title: Title,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private addressBookService: AddressBookService,
    private confirmationService: ConfirmationService
  ) {
    // this.registry_end_customer_contact_id = config.data.registry_end_customer_contact_id;
    // this.registry_end_customer_id = config.data.registry_end_customer_id;
    // console.log('RECC', this.registry_end_customer_contact_id);
    // console.log('REC', this.registry_end_customer_id);
  }

  ngOnInit() {
    if (this.registry_end_customer_contact_id) {
      this.addressBookService
        .addressBookControllerGetOne({ id: this.registry_end_customer_contact_id })
        .subscribe({
          next: res => {
            this.registry_end_customer_contact = res.data;
            this.frm.patchValue({
              name: res.data.name,
              last_name: res.data.last_name,
              job_title: res.data.job_title,
              email: res.data.email,
              alternative_email: res.data.alternative_email,
              address: res.data.address,
              province: res.data.province,
              city: res.data.city,
              zip_code: res.data.zip_code,
              phone_number: res.data.phone_number,
              alternative_phone_number: res.data.alternative_phone_number,
              fax_number: res.data.fax_number,
              building: res.data.building,
              floor: res.data.floor,
              room: res.data.room,
              directions: res.data.directions,
              linkedin_url: res.data.linkedin_url,
              notes: res.data.notes,
            });
          },
        });
    }
  }

  close() {
    this.closing.emit();
  }

  save() {
    const body: AddressBookDtoCreate = {
      name: this.frm.value.name!,
      last_name: this.frm.value.last_name!,
      job_title: this.frm.value.job_title ?? undefined,
      email: this.frm.value.email ?? undefined,
      alternative_email: this.frm.value.alternative_email ?? undefined,
      address: this.frm.value.address ?? undefined,
      province: this.frm.value.province ?? undefined,
      city: this.frm.value.city ?? undefined,
      zip_code: this.frm.value.zip_code ?? undefined,
      phone_number: this.frm.value.phone_number ?? undefined,
      alternative_phone_number: this.frm.value.alternative_phone_number ?? undefined,
      fax_number: this.frm.value.fax_number ?? undefined,
      building: this.frm.value.building ?? undefined,
      floor: this.frm.value.floor ?? undefined,
      room: this.frm.value.room ?? undefined,
      directions: this.frm.value.directions ?? undefined,
      linkedin_url: this.frm.value.linkedin_url ?? undefined,
      notes: this.frm.value.notes ?? undefined,
      registry_id: this.registry_end_customer_id!,
    };

    //aggiorna
    if (this.registry_end_customer_contact_id) {
      const updateBody: AddressBookDtoUpdate = body;

      this.confirmationService.confirm({
        message: `Confermi la modifica dell'utilizzatore?`,
        header: 'Attenzione',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Sì',
        acceptButtonStyleClass: 'bg-danger',
        rejectButtonStyleClass: 'p-button-outlined',
        accept: () => {
          console.log(updateBody);

          this.addressBookService
            .addressBookControllerUpdate({
              body: updateBody,
              id: this.registry_end_customer_contact_id!,
            })
            .subscribe({
              next: res => {
                this.closing.emit(res.data);
                // this.ref.close({
                //   // frmValue: this.frm.value,
                //   registry_end_customer_contact_id: res.data.id,
                // });
              },
            });
        },
      });
    } else {
      //crea
      const createBody: AddressBookDtoCreate = body;

      this.confirmationService.confirm({
        message: `Confermi la creazione dell'utilizzatore?`,
        header: 'Attenzione',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Sì',
        acceptButtonStyleClass: 'bg-danger',
        rejectButtonStyleClass: 'p-button-outlined',
        accept: () => {
          console.log(createBody);
          this.addressBookService
            .addressBookControllerCreate({
              body: createBody,
            })
            .subscribe({
              next: res => {
                this.closing.emit(res.data);
                // this.ref.close({
                //   // frmValue: this.frm.value,
                //   registry_end_customer_contact_id: res.data.id,
                // });
              },
            });
        },
      });
    }
  }
}
